import React, { useEffect, useState } from "react";
import { Tooltip, Form, Button, message } from "antd";
import { connect } from "dva";
import DownloadFile from "nbugs-pc-downloadfile";
import ImagesUpload from "nbugs-images-upload";
import { stringify } from "qs";
import moment from "moment";
import Container from "../../../../components/Container";
import ListPage from "../../../../components/ListPage";
import ListSearch from "../Components/HooksSearch";
import useRequest from "../DataStatistic/hooks/use-table-state";
import {
  getStatusList,
  getTypeList
} from "../../../../services/activitySign/global";
import { url } from "../../../../services/service-utils";
import {
  selectedList,
  getPhotoArrayUrl,
  getListArrayUrl
} from "../../../../services/activitySign/selected";
import { GetQueryString } from "../../../../utils/utils";
import styles from "./index.less";

const { ListTable } = ListPage;

const Selected = props => {
  const appId = GetQueryString("appId") || 40;
  const {
    pageInfo,
    list,
    loading,
    params,
    handlePaginationChange,
    handleQueryChange
  } = useRequest(selectedList);

  const [typeList, setTypeList] = useState([]);
  const [nowGroupIds, setNowGroupIds] = useState([]);
  const [startDownload, setStartDownload] = useState(false);
  const [statusList, setStatusList] = useState([]);
  const [bizIdList, setBizIdList] = useState([]);
  const [downloadUrlLoading, setDownloadUrlLoading] = useState(false);

  useEffect(() => {
    getStatusList().then(res => {
      setStatusList(res);
    });
    getTypeList().then(res => {
      setTypeList(res);
    });
  }, []);

  // 点击导出的回调
  const handleSendUrl = type => {
    // 原图片导出和文件导出处理逻辑相同，后来后端变更，逻辑也变更。
    const typeRequest = {
      photo: getPhotoArrayUrl,
      excel: getListArrayUrl
    };
    const requestActionListStr = bizIdList.join(",");
    const requestParams = { ...params, bizIdList: requestActionListStr };
    if (type === "photo") {
      setDownloadUrlLoading(true);
      typeRequest[type](requestParams)
        .then(res => {
          setDownloadUrlLoading(false);
          if (res) {
            // window.open(res);
            setNowGroupIds([res]);
            setStartDownload(true);
          } else {
            message.info("暂无图片可导出");
          }
        })
        .catch(() => {
          setDownloadUrlLoading(false);
        });
    }
    if (type === "excel") {
      window.open(
        `${
          url.activitySign
        }/activity/recommend-record/download-excel?${stringify({
          ...requestParams,
          appId
        })}`
      );
    }
  };

  // 文件下载完成
  const handleDownloadFileFinish = () => {
    setStartDownload(false);
    setNowGroupIds([]);
    setDownloadUrlLoading(false);
  };

  // 取消下载的回调
  const handleCancelDownload = () => {
    setStartDownload(false);
    setDownloadUrlLoading(false);
  };

  // 切换分页重置选中的活动
  const handleResetBizIdList = () => [setBizIdList([])];

  const onPageChange = (page, pageSize) => {
    handleResetBizIdList();
    handlePaginationChange(page, pageSize);
  };

  const columns = [
    {
      title: "图片",
      dataIndex: "photoGroupId",
      key: "photoGroupId",
      width: 120,
      render: photoGroupId => {
        const imagesUploadProps = {
          groupId: photoGroupId,
          type: "pc",
          edit: 1,
          isTable: true
        };
        return photoGroupId ? <ImagesUpload {...imagesUploadProps} /> : "-";
      }
    },
    {
      title: "活动名称",
      dataIndex: "activityName",
      key: "activityName",
      width: 260,
      render: activityName =>
        activityName ? (
          <Tooltip placement="top" title={activityName}>
            <span>
              {activityName && activityName.length <= 20
                ? activityName
                : `${activityName.substring(0, 20)}...`}
            </span>
          </Tooltip>
        ) : (
          <span>-</span>
        )
    },
    {
      title: "内容",
      dataIndex: "content",
      key: "content",
      width: 300
    },
    {
      title: "姓名",
      dataIndex: "userName",
      key: "userName",
      width: 120
    },
    {
      title: "班级/部门",
      key: "deptName",
      dataIndex: "deptName",
      width: 200
    },
    {
      title: "角色",
      key: "userType",
      dataIndex: "userType",
      width: 120
    },
    {
      title: "组织名称",
      key: "orgName",
      dataIndex: "orgName",
      width: 120
    },
    {
      title: "累计打卡天数",
      key: "insistNum",
      dataIndex: "insistNum",
      width: 120
    },
    {
      title: "提交人",
      key: "submitOperator",
      dataIndex: "submitOperator",
      render: submitOperator => {
        return submitOperator ? <span>{submitOperator}</span> : "-";
      },
      width: 200
    },
    {
      title: "内容id",
      dataIndex: "bizId",
      key: "bizId",
      width: 180
    },
    {
      title: "资讯精选",
      key: "level",
      dataIndex: "level",
      width: 120,
      fixed: "right"
    }
  ];

  const containerProps = {
    breStates: 1,
    isSplitBar: 1,
    alertParams: {
      states: !0, // true为展示 false不展示
      type: "info", // 错误类型（success info warning error）四种，默认为warning类型
      message: "说明: 已被精选的内容在对应活动结束后3个月被移除" // 展示的内容
    }
  };

  const { form } = props;

  const searchProps = {
    handleQueryChange,
    form,
    typeList,
    statusList,
    handleResetBizIdList
  };

  const listPageProps = {
    spinProps: {
      spinning: loading || downloadUrlLoading
    },
    className: styles.root
  };

  const tableProps = {
    columns,
    list,
    pageInfo,
    rowKey: "bizId",
    selfPageNation: pageInfo,
    onPageChange,
    rowSelection: {
      onChange: selectedRowKeys => {
        setBizIdList(selectedRowKeys);
      },
      selectedRowKeys: bizIdList
    }
  };

  const downLoadFileProps = {
    groupIds: nowGroupIds,
    startDownload,
    isFinish: handleDownloadFileFinish,
    zipName: `精选图片导出 ${moment().format("YYYY.MM.DD")}`,
    cancelCallback: handleCancelDownload
  };

  return (
    <Container {...containerProps}>
      <div className={styles.root}>
        <ListPage {...listPageProps}>
          <ListSearch {...searchProps} />
          <div className="divider" />
          <div className="buttonContainer">
            <Button
              style={{ marginRight: 8 }}
              onClick={() => handleSendUrl("photo")}
            >
              精选图片导出
            </Button>
            <Button onClick={() => handleSendUrl("excel")}>列表数据导出</Button>
          </div>
          <ListTable {...tableProps} />
        </ListPage>
      </div>
      <DownloadFile {...downLoadFileProps} />
    </Container>
  );
};

export default connect()(Form.create()(Selected));
